/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Button, Image, Typography } from 'tfc-components';

import banner1 from 'assets/images/home/banner_image_1.png';
import extendBanner from 'assets/images/home/extend_banner.png';
import Section from 'components/organisms/Section';

interface BannerSectionProps {
  onOpenModal?: () => void;
}

const BannerSection: React.FC<BannerSectionProps> = ({ onOpenModal }) => (
  <Section className="p-home_banner">
    <div className="p-home_banner_content">
      <Typography.Heading type="h2" extendClasses="p-home_banner_title f-36x48" fontweight="600">
        Resolve 70% of customer queries instantly with Ask2Auto now
        <Image extendClasses="p-home_banner_extendBanner" imgSrc={extendBanner} alt="extend_banner" ratio={113 / 118} />
      </Typography.Heading>
      <Typography.Text fontweight="400" extendClasses="p-home_banner_description f-20x24">
        Deploy in 5 minutes. Connect to your existing database.
      </Typography.Text>
      <Button onClick={onOpenModal} variant="primary" extendClasses="p-home_banner_button fButton fButton-sm f-16x24">
        Book a demo
      </Button>
      <div className="p-home_banner_trusted">
        <Typography.Text>
          Trusted by leading companies:
        </Typography.Text>
        <div className="p-home_banner_trustedBy">
          <div />
          <div />
        </div>
      </div>
    </div>
    <div className="p-home_banner_image">
      <Image imgSrc={banner1} alt="Google" ratio={2511 / 1223} />
    </div>
  </Section>
);

export default BannerSection;
